module.exports = __webpack_public_path__ + "img/5.9cbf288d.jpg";